import React, { useMemo }         from 'react';
import { TDataTableRow }          from '@typings/components';
import { ICreditUnion }           from '@typings/accountManagement';
import { ISearchInvoice }         from '@typings/invoiceManagement';
import { EAppPage }               from '@enums/common';
import { EAccountPage }           from '@enums/accountManagement';
import {
  formatCurrency,
  formatParsedZoneDate,
}                                 from '@utils/commonFunctions';
import { INVOICE_STATUS_NAME }    from '@modules/invoiceManagement/utils/suggestions';
import { INVOICES_TABLE_HEADERS } from '@modules/accountManagement/utils/tableHeaders';
import {
  DataTable,
  SearchPagination,
}                                 from '@components/index';
import { AccountPageWrapper }     from '@modules/accountManagement/components/AccountPageWrapper';

const getTableRows = (
  invoices    : ISearchInvoice[],
  cuid        : string,
): TDataTableRow[] => invoices.map((invoice) => [{
  value : invoice.invoiceNumber,
  link  : `${EAppPage.AccountManagement}/${cuid}/${EAccountPage.Invoices}/${invoice.id}`,
}, {
  value: formatParsedZoneDate(invoice.invoiceDate),
}, {
  value : INVOICE_STATUS_NAME[invoice.status],
  align : 'center',
}, {
  value : formatCurrency(invoice.amount),
  align : 'right',
}]);

interface IProps {
  push               : (path: string) => void;
  invoices           : ISearchInvoice[];
  accountData        : ICreditUnion;
  currentPage        : number;
  rowsPerPage        : number;
  totalInvoicesCount : number;
  isLoading          : boolean;
  handleChangePage   : (page: number)=> void;
  cuid               : string;
}

export const InvoiceListPage: React.FC<IProps> = ({
  push,
  invoices,
  accountData,
  rowsPerPage,
  currentPage,
  totalInvoicesCount,
  isLoading,
  handleChangePage,
  cuid,
}) => {
  const tableRows = useMemo(
    (): TDataTableRow[] => getTableRows(invoices, cuid),
    [invoices, cuid],
  );

  return (
    <AccountPageWrapper
      push   = {push}
      cuInfo = {accountData}
    >
      <DataTable
        headers  = {INVOICES_TABLE_HEADERS}
        rows     = {tableRows}
        loading  = {isLoading}
        maxwidth = "800px"
      />

      {!!totalInvoicesCount && (
        <SearchPagination
          currentPage      = {currentPage}
          rowsPerPage      = {rowsPerPage}
          totalItems       = {totalInvoicesCount}
          handleChangePage = {handleChangePage}
        />
      )}
    </AccountPageWrapper>
  );
};
